import React from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';

import { ProvideAuth } from 'auth';

import LoginLayoutRoute from "layout/loginLayout";
import DashboardLayoutRoute from "layout/dashboardLayout";

import { Login } from 'auth';
import { ProductList } from 'site/product/productList';
import { ProductEdit } from 'site/product/edit/productEdit';
import { ProductNew } from 'site/product/new/productNew';

import { WarrantyList } from 'site/warranty/warrantyList';
import { WarrantyView } from 'site/warranty/warrantyView';

import { StoreList } from 'site/wheretobuy/storeList';
import { StoreEdit } from 'site/wheretobuy/edit/storeEdit';
import { StoreNew } from 'site/wheretobuy/new/storeNew';

import { ContactList } from 'site/contact/contactList';
import { ContactView } from 'site/contact/contactView';

import { JoinList } from 'site/join/joinList';
import { JoinView } from 'site/join/joinView';

function App() {
  return (
    <ProvideAuth>
      <Router>
        <Switch>
          <DashboardLayoutRoute path="/admin/products" component={ProductList} />
          <DashboardLayoutRoute path="/admin/product/edit/:id" component={ProductEdit} />
          <DashboardLayoutRoute path="/admin/product/new" component={ProductNew} />

          <DashboardLayoutRoute path="/admin/warranty" component={WarrantyList} />
          <DashboardLayoutRoute path="/admin/warranty-reg/:id" component={WarrantyView} />

          <DashboardLayoutRoute path="/admin/contacts" component={ContactList} />
          <DashboardLayoutRoute path="/admin/contact/:id" component={ContactView} />

          <DashboardLayoutRoute path="/admin/join" component={JoinList} />
          <DashboardLayoutRoute path="/admin/join-reg/:id" component={JoinView} />

          <DashboardLayoutRoute path="/admin/stores/:country" component={StoreList} />
          <DashboardLayoutRoute path="/admin/store/edit/:id" component={StoreEdit} />
          <DashboardLayoutRoute path="/admin/store/new" component={StoreNew} />
          
          <LoginLayoutRoute path="/admin/login" component={Login} />
          <Route exact path="/admin/dashboard">
            <Redirect to="/admin/products" />
          </Route>
          <Route exact path="/admin/stores">
            <Redirect to="/admin/stores/AU" />
          </Route>
          <Route path="/">
            <Redirect to="/admin/products" />
          </Route>
        </Switch>
      </Router>
    </ProvideAuth>
  );
}

export default App;
